import purchase from '@/api/purchase-order/order'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { includes, join, isEmpty } from 'lodash'

export const state = {
  ...baseState,
  suppliers: [],
  products: [],
  measures: [],
  vendor_id: [],
  location_id: [],
  purchaseTypes: [],
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '' } = {}) => {
    if (chosenProduct !== undefined) {
      return state.products
        // .filter(
        //   p =>
        //     !includes(
        //       chosenProduct.map(el => el.product_id),
        //       p.product_id
        //     )
        // )
        .filter(
          p =>
            search
              .split(' ')
              .every(s =>
                p.product_name_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            search
              .split(' ')
              .every(s => p.barcode.toLowerCase().includes(s.toLowerCase()))
        )
        .slice(0, 400)
    }
    return state.products.slice(0, 400)
  },
  getProductByBarcode: state => ({ chosenProduct, search = '' } = {}) => {
    if (chosenProduct !== undefined) {
      return state.products
        .filter(
          p =>
            !includes(
              chosenProduct.map(el => el.product_id),
              p.product_id
            )
        )
        .filter(p =>
          search
            .split(' ')
            .every(s => p.barcode.toLowerCase().includes(s.toLowerCase()))
        )
        .slice(0, 400)
    }
    return state.products.slice(0, 400)
  },
  getUom: state => uom_cat_id => {
    if (uom_cat_id) {
      return state.measures
        .filter(m => m.uom_cat_id == uom_cat_id)
        .map(el => ({
          value: el.uom_id,
          label: el.uom_name_en
        }))
    }
    return []
  },
  findProduct: state => productId => {
    if (!productId) {
      return {
        barcode: null,
        product_name_en: null
      }
    }
    return state.products.find(p => p.product_id == productId)
  },
  getCostPrice: state => ({ product_id, uom_id }) => {
    let prod = state.products.find(p => p.product_id == product_id)
    let pro_price = prod.sale_code.find(s => s.uom_id == uom_id)
    if (pro_price !== undefined) {
      if (pro_price.product_price !== undefined) {
        return pro_price.product_price ? pro_price.product_price.cost : 0
      }
    }
    return pro_price ? pro_price.cost : 0
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_MEASURE(state, data) {
    state.measures = data
  },
  SET_SUPPLIER(state, data) {
    state.suppliers = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_VENDOR(state, data) {
    state.vendor_id = data
  },
  SET_PURCHASE_TYPE(state, data) {
    state.purchaseTypes = data
  },
  PUSH_NEW_PURCHASE_TYPE(state, data) {
    // if not exists
    let exist = state.purchaseTypes.find(
      c => c.purchase_type_id == data.purchase_type_id
    )
    if (!exist) {
      state.purchaseTypes.push(data)
    }
  },
  CLEAR_SETUP(state) {
    state.products = []
    state.measures = []
    state.suppliers = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        vendor_id: context.state.vendor_id,
        filter: {
          search: context.state.search,
          location_id: context.state.location_id,
          date_between: join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return purchase.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return purchase.store(data)
  },
  update(context, { id, data }) {
    return purchase.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await purchase.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return purchase.destroy(id)
  },
  async getSupplier(context) {
    let response = await purchase.supplier()
    context.commit('SET_SUPPLIER', response.data)
    return response
  },
  async getProduct(context) {
    let response = await purchase.product()
    context.commit('SET_PRODUCT', response.data)
    return response
  },
  async getMeasure(context) {
    let response = await purchase.measure()
    context.commit('SET_MEASURE', response.data)
    return response
  },
  async getVendor(context) {
    let response = await purchase.vendor()
    return response
  },
  async getPurchaseType(context) {
    let response = await purchase.purchaseType()
    context.commit('SET_PURCHASE_TYPE', response.data)
    return response
  },
  printPdf(context, id) {
    return purchase.printPdf(id)
  },
  downloadTemplate(context) {
    return purchase.downloadTemplate()
  }
}
